// extracted by mini-css-extract-plugin
export var teaserItem = "styles-module--teaserItem--glRNs";
export var image = "styles-module--image--MD5HL";
export var tagline = "styles-module--tagline--y2pZp";
export var withImage = "styles-module--withImage--nuYie";
export var headline = "styles-module--headline--RueYp";
export var link = "styles-module--link--m+cIN";
export var textContainer = "styles-module--textContainer--W2P6b";
export var left = "styles-module--left--VzHW3";
export var right = "styles-module--right--mBcY1";